import Collections from './Collections';

export default Collections;



// WEBPACK FOOTER //
// ./src/components/Collections/index.js